import cfg from '../package.json';

type PackageJson = {
  version: string;
};

const typedCfg = cfg as PackageJson;

export const appInfo = {
  title: 'Кабінет лабораторії 2.0',
  version: String(typedCfg.version ?? ''),
};
